import { render, staticRenderFns } from "./EmployersList.vue?vue&type=template&id=fc72010a&scoped=true"
import script from "./EmployersList.vue?vue&type=script&lang=js"
export * from "./EmployersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc72010a",
  null
  
)

export default component.exports